<template>

  <div class="page_container">
      

  </div>

  
 
  <van-form @submit="onSubmit">
  <van-cell-group inset>
    <van-field
      v-model="username"
      name="name"
      label="user"
      :rules="[{ required: true, message: 'require' }]"
    />
    <van-field
      v-model="password"
      type="password"
      label="pass"
      name="pass"
      
      :rules="[{ required: true, message: 'require' }]"
    />
  </van-cell-group>
  <div style="margin: 16px;">
    <van-button round block type="primary" native-type="submit">
      submit
    </van-button>
  </div>
</van-form>




  
  

  
    
  </template>
  
  <script setup >


import { useRouter } from 'vue-router';
import { jingxinAdminLogin } from '@/api/apiService'; // 你自己的上传地址获取方法


  const router = useRouter();
  import { ref } from 'vue';


  const username = ref('user');



    const password = ref('');
    const onSubmit = async (values) => {

      try{

        console.log('submit', values);
  const loginObj = {
          userName: username.value,
          password: password.value,
        };

    const response = await jingxinAdminLogin(loginObj);

    console.log('response', response);

    if(response && response.code == 0){
      console.log('response', response);

      const expireTime = Date.now() + 10 * 60 * 1000; // 当前时间+10分钟
      localStorage.setItem('isAdmin', '1');
      localStorage.setItem('adminExpire', expireTime.toString());


      router.push({ name: 'AdminPage' });
    }

      }catch(err){
        console.log('err', err);
      }
      


    };
  
 


  




  </script>
  
  <style scoped>

  

  .page_container {
    display: flex;
    flex-direction: column;
    align-content: center;
    
    
  }

  






  </style>